//
// SiblingDefinitionsMenu for RecordInspector
//
// Informational list of sibling definitions, grouped by base with nested extensions.
//

import { observer } from 'mobx-react-lite'
import { forwardRef, Fragment } from 'react'
import { useStore } from '../../../stores'

import { Icon, Menu, MenuHeader, MenuItem, TreeItem } from '../../../components'
import { groupExtensionsByBaseFromDefinitions } from '../../../stores/data/extension-groups'

const LinkTag = () => {
    const { app } = useStore()
    return (
        <span className="role" title={app.text('From linked record')}>
            <Icon name="link" size="text" style={{ position: 'relative', top: 1 }} />
        </span>
    )
}

const ExtensionRow = forwardRef(function ExtensionRow({ name, hasLink, style }, ref) {
    return (
        <TreeItem ref={ref} style={style}>
            {name}
            {hasLink ? <LinkTag /> : null}
        </TreeItem>
    )
})

const BaseRow = forwardRef(function BaseRow({ name, hasLink, style }, ref) {
    return (
        <TreeItem ref={ref} style={style}>
            {name}
            {hasLink ? <LinkTag /> : null}
        </TreeItem>
    )
})

export const SiblingDefinitionsMenu = observer(function SiblingDefinitionsMenu({
    worksheet,
}) {
    const { app, data } = useStore()
    const parentGid = worksheet.parent ? worksheet.parent.gid : null
    const linkDefinitionGids = new Set()
    if (parentGid) {
        for (const record of data.records.values()) {
            if (record && record.parent === parentGid && record.is_link) {
                linkDefinitionGids.add(record.definition)
            }
        }
    }

    const families = groupExtensionsByBaseFromDefinitions(
        worksheet.sibling_definitions,
        data.definitions,
        { linkDefinitionGids }
    )

    return (
        <Menu>
            <MenuHeader>{app.text('Sibling definitions')}</MenuHeader>
            {families.length ? (
                families.map(family => (
                    <Fragment key={family.key}>
                        <BaseRow
                            name={family.base.name}
                            hasLink={family.base.hasLink}
                            style={{ paddingLeft: 5 }}
                        />
                        {family.extensions.map(extension => (
                            <ExtensionRow
                                key={extension.key}
                                name={extension.name}
                                hasLink={extension.hasLink}
                                style={{ paddingLeft: 15 }}
                            />
                        ))}
                    </Fragment>
                ))
            ) : (
                <MenuItem disabled>{app.text('No siblings')}</MenuItem>
            )}
        </Menu>
    )
})
